import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ConstantsProviders {
  public apiUrl: string;
  public apiUrlShipHawk: string;
  public apiHost: string;
  public boxBackend: string;
  public apiElite: string;
  constructor() {
    this.apiUrlShipHawk = environment.apiBase + '/api/shiphawk';
    this.apiElite = environment.otherApis.apiBaseElite + '/api';
    this.boxBackend = environment.otherApis.boxApi + '/api';
  }
}
